// Time-code labels and display order, shared by reports, PDFs and benchmark pages.
export const CODE_DESCRIPTIONS = {
  TCO: 'Time Cards Out',
  TTD: 'Time to Draw',
  TPU: 'Time Pick Up',
  // Roulette breakdown codes
  SPT: 'Spin Time',
  SWT: 'Sweep Time',
  OPT: 'Outside Pay Time',
  IPT: 'Inside Pay Time',
  PTT: 'Pay/Take Time',
  // Baccarat breakdown codes
  DDT: 'Dealer Draw Time',
  SBP: 'Side Bet Pay Time',
  MBP: 'Main Bet Pay Time',
  CUT: 'Cards Up Time',
  ABP: 'All Bet Pay Time',
  // Carnival breakdown codes
  PAT: 'Player Action Time',
  DAT: 'Dealer Action Time',
  PYT: 'Payout Time',
  TBR: 'Time Between Rounds',
  DPT: 'Deal & Pay Time',
  TRT: 'Total Round Time',
  TST: 'Total Shuffle Time',
  AST: 'After Shuffle Time',
  TCT: 'Total Change Time',
  ACT: 'After Change Time',
  OTT: 'Other Pause Time',
  AOT: 'After Other Time',
};

export const CODE_ORDER = ['TCO', 'TTD', 'TPU', 'SPT', 'SWT', 'OPT', 'IPT', 'PTT', 'DDT', 'SBP', 'MBP', 'CUT', 'ABP', 'PAT', 'DAT', 'PYT', 'DPT', 'TBR', 'TRT', 'TST', 'AST', 'TCT', 'ACT', 'OTT', 'AOT'];
